"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchProductsBySku = void 0;
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const brand_provider_1 = require("../../providers/brand.provider");
const query_1 = require("../../providers/query");
const services_1 = require("../../services");
const isGenericReseller_1 = require("../../utils/helpers/isGenericReseller");
const product_1 = require("../../utils/helpers/product");
/**
 * Infinite query
 */
const useSearchProductsBySku = ({ skus, resellerSlug, uf, businessUnit, pageSize = 10, initialData = { facets: [], count: 0, products: [] }, context = query_1.BarrilQueryClientContext, }) => {
    const productsService = (0, react_1.useMemo)(() => new services_1.ProductsService(services_1.tdcClient), []);
    const skusString = skus.map((sku) => sku.toString());
    const hasSkus = skusString.length > 0;
    const params = {
        businessUnit: businessUnit !== null && businessUnit !== void 0 ? businessUnit : brand_provider_1.BrandProvider.getBrand(),
        pageSize,
        catalogSlug: !(0, isGenericReseller_1.isGenericReseller)(resellerSlug) ? resellerSlug : undefined,
        state: uf,
    };
    const { data, error, hasNextPage, isError, isFetching, isFetchingNextPage, isInitialLoading, isRefetching, fetchNextPage, refetch, } = (0, react_query_1.useInfiniteQuery)({
        queryKey: query_1.ProductQueryKeys.GetBySkus(skusString, params),
        queryFn: ({ pageParam = 0, signal }) => __awaiter(void 0, void 0, void 0, function* () {
            if (skusString.length === 0) {
                return initialData;
            }
            const result = yield productsService.getProductsBySkus(Object.assign(Object.assign({}, params), { skus: skusString, page: pageParam + 1 }), { signal });
            return result;
        }),
        getNextPageParam: (response, allPages) => response.products.length === pageSize ? allPages.length : undefined,
        enabled: hasSkus,
        context,
        placeholderData: { pages: [initialData], pageParams: [undefined] },
    });
    /*
     * Este código contorna um bug na tipagem do `select` do react-query v4. Quando atualizarmos para a v5, podemos jogar esse trecho direto na função select().
     * Issue de referência: https://github.com/TanStack/query/issues/3065
     */
    const products = (0, react_1.useMemo)(() => (data === null || data === void 0 ? void 0 : data.pages) ? (0, product_1.deduplicateProductsBySku)(data.pages.flatMap((page) => page.products)) : [], [data === null || data === void 0 ? void 0 : data.pages]);
    return {
        data,
        products,
        isLoading: isInitialLoading || isRefetching,
        isError,
        error,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        refetch,
        fetchNextPage,
    };
};
exports.useSearchProductsBySku = useSearchProductsBySku;
